import styled from "styled-components"
import { ArticleWrapper } from "../article-preview/article-preview-elements"
import { ArticlesListWrapperStyles } from "./articles-list-styles"
import { BreakPoints, media } from "../../helpers/rwd"

export const ArticlesListWrapper = styled.div`
  &.vertical {
    display: flex;
    width: 100%;
    ${ArticleWrapper} {
      flex: 1;
    }
  }
  &.vertical.slider-mode {
    display: block;
    & .slick-slide {
      padding: 0 20px;
    }
    ${ArticleWrapper} {
      margin: 0 auto;
    }
  }
  ${media.max(BreakPoints.desktop)} {
    ul.slick-dots{
      bottom: -40px !important;
      margin: 1px !important;
    }
  }
  ${media.max(BreakPoints.tablet)} {
    .slick-dots{
      bottom: -39px !important;
    }
  }
  ${ArticlesListWrapperStyles}
`
